import React from 'react';
import { connect } from 'react-redux';
import fire from '../firebase';
import Loading from '../components/Loading';
// Higher order component that gets snippet from store or dispatches firebase when not available
const withSnippet = Component => {
  class WithSnippet extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        snippet: null
      };
    }
    componentDidMount() {
      const { snippets, ident, isPrivate, snippet } = this.props;
      if (!ident && !snippet) {
        const snippetKeys = Object.values(snippets).map(({ id }) => id);
        const randomIdent =
          snippetKeys[Math.floor(Math.random() * snippetKeys.length)];
        const snippet = Object.values(snippets).find(
          ({ id }) => id === randomIdent
        );
        this.setState({ snippet });
      } else {
        const snippetRef = fire
          .database()
          .ref('snippets/' + (isPrivate ? 'private' : 'public'))
          .orderByChild('id')
          .equalTo(ident);

        snippetRef.once('value', snapshot => {
          const [snap] = Object.values(snapshot.val());
          const [key] = Object.keys(snapshot.val());
          snap &&
            snap.snippet &&
            this.props.onGetSnippet({
              ...snap,
              key
            });
        });
      }
    }

    render() {
      const snippet = this.props.snippet || this.state.snippet;
      return snippet ? (
        <Component {...this.props} snippet={snippet} />
      ) : (
        <Loading />
      );
    }
  }
  // If no ident is given return list of snippetKeys
  const mapStateToProps = ({ snippetState }, ownProps) => {
    const privacy = ownProps.isPrivate || 'public';

    const ident = ownProps.ident;
    if (!ident) {
      return { ...ownProps, snippets: snippetState.snippets[privacy] };
    }
    const snippet = Object.values(snippetState.snippets[privacy]).find(
      ({ id }) => id === ident
    );
    return { snippet, ident, ...ownProps };
  };
  const mapDispatchToProps = dispatch => ({
    onGetSnippet: snippet => dispatch({ type: 'PUBLIC_SNIPPET_ADD', snippet })
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(WithSnippet);
};
export default withSnippet;
